import React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import { getPaymentMethodDisplay } from "../../utils/payment-method-display";

const PaymentMethodSection = ({
  subscriberDetails,
  loading,
  stripeLoading,
  onSetupPayment,
  onUpdatePayment,
}) => {
  const paymentMethod = getPaymentMethodDisplay(subscriberDetails);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography mb={2} variant="h5">
        Payment method
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 1 }}>
          <CircularProgress size={20} />
          <Typography color="text.secondary" variant="body2">
            Loading payment details…
          </Typography>
        </Box>
      ) : paymentMethod.hasPaymentMethod ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
            <CreditCardOutlinedIcon color="primary" sx={{ mt: 0.25 }} />
            <Box>
              {paymentMethod.last4 ? (
                <>
                  <Typography fontWeight={500} variant="body1">
                    {paymentMethod.cardBrand} •••• {paymentMethod.last4}
                  </Typography>
                  {paymentMethod.expiry && (
                    <Typography color="text.secondary" variant="body2">
                      Expires {paymentMethod.expiry}
                    </Typography>
                  )}
                </>
              ) : (
                <Typography variant="body1">
                  Payment method on file
                </Typography>
              )}
            </Box>
          </Box>
          <Button
            color="primary"
            disabled={stripeLoading}
            onClick={onUpdatePayment}
            variant="outlined"
            data-testid="manage-subscriber--Button-stripe-edit"
          >
            Update payment method
          </Button>
        </Box>
      ) : (
        <Box>
          <Alert severity="warning" sx={{ mb: 2 }}>
            No payment method on file. Set up a card so charges can be applied
            to this subscriber.
          </Alert>
          <Button
            color="primary"
            disabled={stripeLoading}
            onClick={onSetupPayment}
            variant="contained"
            data-testid="manage-subscriber--Button-stripe-create"
          >
            Set up payment for charges
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default PaymentMethodSection;
